// The OneSignal App ID (not a secret). Set VITE_ONESIGNAL_APP_ID in mobile/.env.production
// (OneSignal › Settings › Keys & IDs), then rebuild. See mobile/PUSH-SETUP.md.
// The REST API key never goes here or in any VITE_ variable; it lives on the server only.
export const oneSignalAppId = import.meta.env?.VITE_ONESIGNAL_APP_ID || 'YOUR-ONESIGNAL-APP-ID'
